/* BESOCKS · Menu de ordenador: el submenu no se cierra de golpe al salir del enlace.
   Horizon cierra el desplegable en cuanto el puntero sale del <li> del menu (pointerleave -> /deactivate), asi que
   cualquier desvio al bajar al submenu lo cerraba. Aqui ese cierre se retrasa 400 ms: si el puntero vuelve al menu
   o entra en el submenu, no se cierra. El teclado y el movil no cambian. */
(function () {
  if (window.__bsMenuHover) return;
  window.__bsMenuHover = true;

  var DELAY = 400;
  var timers = new WeakMap();

  document.addEventListener('pointerleave', function (event) {
    var item = event.target;
    if (!(item instanceof Element) || event.bsReplay || event.pointerType === 'touch') return;
    if (!item.matches('header-menu .menu-list__list-item:not([slot])')) return;
    // Solo cuando tiene un submenu abierto; si no, se comporta como siempre
    if (!item.querySelector(":scope > [ref='submenu[]']") || !item.querySelector("[aria-expanded='true']")) return;

    event.stopImmediatePropagation();
    clearTimeout(timers.get(item));
    timers.set(item, setTimeout(function () {
      timers.delete(item);
      var menu = item.closest('header-menu');
      // El puntero ha vuelto a este enlace, esta sobre su submenu o ya esta en otro enlace del menu
      if (!menu || menu.querySelector('.menu-list__list-item:hover')) return;
      var leave = new PointerEvent('pointerleave', { bubbles: false, pointerType: 'mouse' });
      leave.bsReplay = true;
      item.dispatchEvent(leave);
    }, DELAY));
  }, true);
})();
